import dayjs from "@/lib/dayjs";
export function getTodaysDate() {
	return dayjs().format("YYYY-MM-DD");
}
